module.exports = __webpack_public_path__ + "img/from_toeic_fraction.b2192037.svg";